import { AddressModel } from "../../address.model";
import { InsuranceCompany } from "./insurance-company.model";
import { OpposingCounsel } from "./opposing-counsel.model";
import { ClientBaseModel } from "./client-base-model";

export class ClientModel extends ClientBaseModel {
    password: string = "";
    gender: string = "";
    maritalStatus: string = "";
    dateOfBirth: string = "";
    driverLicense: string = "";
    licensePlate: string = "";
    healthCardNumber: string = "";
    sin: string = "";
    abAdjusterName: string = "";
    biAdjusterName: string = "";
    claimNumber: string = "";
    isSelected?: any;
    businessUnitId?: string;
    dateOfLoss: string = "";
    title: string = "";
    address: AddressModel = new AddressModel();
    insuranceCompany: InsuranceCompany = new InsuranceCompany();
    opposingCounsel: OpposingCounsel = new OpposingCounsel();
}
